import styled from "styled-components";

const LogOut = styled.div`
  margin: 14px 0 0 0;
  padding: 0;
  font-size: 12px;
`;

export default LogOut;
